export default __webpack_public_path__ + "static/media/dawiyat-odb-logo.62906056.svg";